'use client'

import { usePostCreationStore } from '@/lib/stores/postCreationStore';
import { TwitterPost } from '@/lib/types/posts';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent } from '@/components/ui/card';

export function TwitterEditor() {
  const { currentPost, updatePostField } = usePostCreationStore();
  const twitterPost = currentPost as TwitterPost;
  
  // Character limit for Twitter-style posts
  const MAX_TITLE_LENGTH = 50;
  const MAX_CONTENT_LENGTH = 280;
  
  const titleLength = (twitterPost.title || '').length;
  const contentLength = (twitterPost.content || '').length;
  
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <Label htmlFor="title">Title (Optional)</Label>
          <span className={`text-xs ${titleLength > MAX_TITLE_LENGTH ? 'text-destructive' : 'text-muted-foreground'}`}>
            {titleLength}/{MAX_TITLE_LENGTH}
          </span>
        </div>
        <Input
          id="title"
          placeholder="Brief title (optional)"
          value={twitterPost.title || ''}
          onChange={(e) => updatePostField('title', e.target.value)}
          maxLength={MAX_TITLE_LENGTH}
        />
      </div>
      
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <Label htmlFor="content">Message</Label>
          <span className={`text-xs ${contentLength > MAX_CONTENT_LENGTH ? 'text-destructive' : 'text-muted-foreground'}`}>
            {contentLength}/{MAX_CONTENT_LENGTH}
          </span>
        </div>
        <Textarea
          id="content"
          placeholder="What's happening?"
          value={twitterPost.content || ''}
          onChange={(e) => updatePostField('content', e.target.value)}
          maxLength={MAX_CONTENT_LENGTH}
          className="min-h-[120px] resize-none"
        />
      </div>
      
      <div className="pt-4">
        <Label className="mb-2 block">Preview</Label>
        <Card className="overflow-hidden">
          <CardContent className="p-6">
            {twitterPost.title && (
              <h3 className="font-semibold text-sm mb-2">{twitterPost.title}</h3>
            )}
            <p className="text-sm whitespace-pre-wrap">{twitterPost.content}</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
} 